import { render, staticRenderFns } from "./ContactActionsTasks.vue?vue&type=template&id=72b7afa9&scoped=true&"
import script from "./ContactActionsTasks.vue?vue&type=script&lang=js&"
export * from "./ContactActionsTasks.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionsTasks.vue?vue&type=style&index=0&id=72b7afa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7afa9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/circleci/repo/components/Loader.vue').default})
